import StoreLocatorContainer from '@components/storelocator/StoreLocatorContainer';
import { configureStoreLocatorStore } from '@state';
import { initQuerySync } from '@utils/storelocator';
import React from 'react';
import { Provider } from 'react-redux';
const store = configureStoreLocatorStore();
if (location.pathname.split('/').length < 6) {
    initQuerySync(store);
}
const StoreLocatorApp = (props) => {
    return (React.createElement(Provider, { store: store },
        React.createElement(StoreLocatorContainer, Object.assign({}, props))));
};
export default StoreLocatorApp;
